import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store.js'
require('@/assets/styles/timeline-style.css')

Vue.config.productionTip = false
Vue.prototype.$filterStore = [];

new Vue({
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
